import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { User } from "../../types/users";

const initialState: User = {
  username: "",
  role: "",
  email: "",
  _id: "",
  permissions: [],
  tasks: [],
  submissions: [],
  transactions: [],
};

export const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    // Used by BetterAuth login — receives the full user object from GET /auth/me
    setUser: (state, action: PayloadAction<Partial<User>>) => {
      return { ...initialState, ...action.payload };
    },
    logout: () => initialState,
  },
});

export const { setUser, logout } = usersSlice.actions;
export default usersSlice.reducer;
